import React from 'react';
import { PRICE } from '../data/catio';
interface PriceBlockProps {
  id?: string;
  className?: string;
}

/** Single price in clean modern sans. No crossed-out price, discount or installments. */
export function PriceBlock({
  id,
  className = ''
}: PriceBlockProps) {
  return <div id={id} className={`flex flex-col items-center ${className}`} data-id="element-109" data-mp="27vzz5ezvgqzc">
      <p className="flex items-start font-sans font-extrabold leading-none tracking-[-0.03em] text-ink" data-id="element-110" data-mp="27tx1c8sh9tk2">
        <span className="mt-2 text-[1.5rem] sm:text-[1.7rem]" data-id="element-111" data-mp="1k4cj5s45f0bu">{PRICE.currency}</span>
        <span className="text-[4.5rem] tabular-nums sm:text-[5.2rem]" data-id="element-112" data-mp="1g6ojkbrigjdm">{PRICE.value}</span>
      </p>
      <p className="label-tech mt-3 text-graphite" data-id="element-113" data-mp="1txjj2xg4do4j">{PRICE.note}</p>
    </div>;
}